import { render, staticRenderFns } from "./PazarSherkatiHero.vue?vue&type=template&id=0f617224&scoped=true"
import script from "./PazarSherkatiHero.vue?vue&type=script&lang=js"
export * from "./PazarSherkatiHero.vue?vue&type=script&lang=js"
import style0 from "./PazarSherkatiHero.vue?vue&type=style&index=0&id=0f617224&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f617224",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer,VLayout})
